import { render, staticRenderFns } from "./AddScheduling.vue?vue&type=template&id=9367215c&"
import script from "./AddScheduling.vue?vue&type=script&lang=ts&"
export * from "./AddScheduling.vue?vue&type=script&lang=ts&"
import style0 from "./AddScheduling.vue?vue&type=style&index=0&id=9367215c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports